<template>
<div id="app">
</div>
</template>
<script>
export default {
    name:"app",
    data() {
        return{
        }
    },
    mounted() {
        localStorage.clear();
    },
    methods: {
        
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/clear.vue